import { brand } from 'config';
/**
 *
 * @returns {{isBcom: boolean, isMcom: boolean}}
 */
export const useBrand = () => {
  const isMcom = brand === 'mcom';
  return {
    isBcom: !isMcom,
    isMcom,
  };
};

export default useBrand;
